// extracted by mini-css-extract-plugin
module.exports = {"leftButton":"UISides_leftButton__3rN42","rightButton":"UISides_rightButton__LIBJ9"};